import React, { Suspense } from 'react'
import { string, node, bool } from 'prop-types'
import { FrameworkContext } from 'mage-deps/@klarna/mp-ui'
import { hooks } from 'mage-i18n'
import CenteredLoader from '../components/CenteredLoader'

PageWrapper.propTypes = {
  name: string,
  children: node,
  parentName: string,
  overrideTopBarConfig: bool,
  urlPath: string
}

function PageWrapper ({ name, children, parentName, overrideTopBarConfig, urlPath }) {
  const t = hooks.useTranslator()

  const { setTopBarContext = () => {} } = React.useContext(FrameworkContext)

  React.useEffect(() => {
    const title = t(`static-pages.${name}.pageTitle`) || t(`static-pages.${parentName}.pageTitle`)

    if (title) {
      if (!overrideTopBarConfig) {
        setTopBarContext({
          title
        })
      }
      document.title = `${title} | Klarna Merchant Portal`
    }
  }, [t, overrideTopBarConfig])

  return (
    <Suspense fallback={<CenteredLoader />}>
      <div data-testid={`page[${urlPath}]`}>
        {children}
      </div>
    </Suspense>
  )
}

export default PageWrapper
